import React from 'react';
import { TypedMemo } from '../../common/types';
import { ClaimReleaseModal } from './ClaimReleaseModal';
import { CatalogAddModalsState } from './useCatalogAddModals';

interface CatalogAddModalsProps {
  accountId: number;
  artistName: string;
  modals: CatalogAddModalsState;
  /** Opens the step-by-step "Add a song" page (design catalog-add-song). */
  onAddSong: () => void;
}

/**
 * The claim of a suggestion. Every other way into the catalog is the "Add a song" page, which
 * replaced the "Add a release" and "Add an unreleased track" modals (design catalog-add-song).
 */
const CatalogAddModalsComponent: React.FC<CatalogAddModalsProps> = ({ accountId, artistName, modals, onAddSong }) => (
  <ClaimReleaseModal
    isOpen={modals.isClaimOpen}
    accountId={accountId}
    fallbackArtistName={artistName}
    initialCatalogTrackMaid={modals.claimMaid}
    initialSnapshot={modals.claimSnapshot}
    suggestion={modals.suggestion}
    claimRoute={modals.route}
    closeModal={modals.closeClaim}
    onAddRelease={onAddSong}
    onAddUnreleased={onAddSong}
  />
);

export const CatalogAddModals = TypedMemo(CatalogAddModalsComponent);
